if (!customElements.get('cart-toast')) {
  class CartToast extends HTMLElement {
    connectedCallback() {
      this._timeout = null;
      this._messageEl = this.querySelector('[data-cart-toast-message]');
      document.addEventListener('cart:toast', (e) => this.show(e.detail));
      this.addEventListener('click', () => this.hide());
    }

    show({ count, type, message }) {
      clearTimeout(this._timeout);

      this.classList.toggle('cart-toast--error', type === 'error');

      if (type === 'error' || message) {
        this._messageEl.textContent = message || '';
      } else {
        const qty = parseInt(count, 10) || 1;
        const isPlural = qty !== 1;

        let template;
        if (type === 'remove') {
          template = isPlural
            ? (this.dataset.i18nRemovedPlural || '[count] items verwijderd uit winkelwagen')
            : (this.dataset.i18nRemoved || '[count] item verwijderd uit winkelwagen');
        } else {
          template = isPlural
            ? (this.dataset.i18nAddedPlural || '[count] items toegevoegd aan winkelwagen')
            : (this.dataset.i18nAdded || '[count] item toegevoegd aan winkelwagen');
        }

        this._messageEl.textContent = template.replace('[count]', qty);
      }

      this.setAttribute('aria-hidden', 'false');
      this.classList.add('is-visible');

      const duration = parseInt(this.dataset.duration, 10) || 3500;
      this._timeout = setTimeout(() => this.hide(), duration);
    }

    hide() {
      clearTimeout(this._timeout);
      this.classList.remove('is-visible', 'cart-toast--error');
      this.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('cart-toast', CartToast);
}
